import { Component, EventEmitter, Injectable, Output } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccessToken, TemporaryPaste, Utente } from '../class/userinterface';
import { AccessoExagerato } from '../class/userinterface';
import { Apiservice } from './api.service';
import { environment } from '../../environments/environment';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ComponentService } from './component.service';




@Injectable({
  providedIn: 'root'
})
export class Utenteservice {
  @Output() changedUser = new EventEmitter(); // emitter per cambio utente
  private AnnoRiferimento = new BehaviorSubject<any>('');
  currentAnno='';
  GruppiFunzioni = [
    {
      text:'Tutte Funzioni',
      id:'A'
    },
    {
      text:'Funzioni Contabilita',
      id:'C'
    },
    {
      text:'Funzioni Rifiuti',
      id:'R'
    },    
    {
      text:'Funzioni Magazzino',
      id:'M'
    },
    {
      text:'Funzioni Definite come D',
      id:'D'
    },    
  ];

 
  soloApp=true;

    CredenzialiRentri={
    "username": "demo",
    "password": "demo",
    "codiceFiscaleAzienda": "05669600636",
    "clientId": "B42777D9-0C64-492E-BAE0-27D176B48732@RENTRI",
    "clientSecret": "nj5-98t^nA"
  }
  public UltimoAccesso = new BehaviorSubject<any>('');
  public temporaryPaste=new TemporaryPaste();
  public AnnoRiferimento1:string;
  public CreateEvent:boolean=false;
  public checSessionError=true; // se true vengono eliminati eventuali altri messaggi di errori in interceptor

  public TokenLoggato = new AccessToken;
  public AccessiExagerato = new AccessoExagerato;
  InfoUtenteConnesso = new Utente;
  public InfoDatiUtenteConnesso = new Utente;
  //tipoutente = [{ id: 1, descrizione: 'OWNER' }, { id: 2, descrizione: "SUPER ADMINISTRATOR" }, { id: 3, descrizione: "ADMINISTRATOR" }, { id: 4, descrizione: "ADVANCED USER" }, { id: 5, descrizione: "STANDARD USER" },{ id: 6, descrizione: "STANDARD WEB" }]
  tipoutente = [{ id: 1, descrizione: 'owner' }, { id: 2, descrizione: "super administrator" }, { id: 3, descrizione: "administrator" }, { id: 4, descrizione: "ADVANCED USER" }, { id: 5, descrizione: "STANDARD USER" },{ id: 6, descrizione: "RENTRI" },{ id: 7, descrizione: "API" },{ id: 8, descrizione: "APP" },{ id: 9, descrizione: "API ESTERNO" },{ id: 10, descrizione: "AGENTE" },{ id: 11, descrizione: "UTENTE SEGRETERIA" }]

  AnniInlinea=[];
  httpClientNoInterceptor:any;

  constructor(private httpClientBack:HttpBackend,private router : Router,private httpClient:HttpClient, private componentService:ComponentService) {
    this.httpClientNoInterceptor=new HttpClient(httpClientBack)
    this.AnnoRiferimento = new BehaviorSubject<any>('');

   }
   
   setValueAnnoRiferimento(newValue): void {
    this.AnnoRiferimento.next(newValue);
    this.currentAnno=newValue;
    this.InfoDatiUtenteConnesso.annoSelected=newValue;
    sessionStorage.setItem('userrentrincloud', JSON.stringify(this.InfoUtenteConnesso));
    this.currentAnno=newValue;

    //alert("Ecco Anno "+newValue);
  }
  getValueAnnoRiferimento(): Observable<boolean> {
    return this.AnnoRiferimento.asObservable();
  }

  public getSession() {

    var obj = {};
    if (typeof sessionStorage.userrentrincloud !== "undefined") {
      obj = JSON.parse(sessionStorage.userrentrincloud);
    }
    return obj;
  }


  public AllUserAccessi() {
    var UtentiCheHannoAvutoAccesso = JSON.parse(localStorage.getItem('artemide_credenziali'));
    return UtentiCheHannoAvutoAccesso;
  }
  getDimensionsByFilter(id, object) {
    return object.filter(x => x.id === id);
  }

  public IsLogged() {
    let MySession = <Utente>this.getSession();
    return MySession.logIn;
    //return  JSON.parse(sessionStorage.userrentrincloud);

  }

  getAllStorage() {
    var archive = [],
        keys = Object.keys(sessionStorage),
        i = 0, key;   
        
    for (; key = keys[i]; i++) {
        archive.push( key + '=' + sessionStorage.getItem(key));
    }
    return archive;
}

  public LogOut() {
    
    this.checSessionError=false;
    let httpOptions = {
      headers: new HttpHeaders().set(
        "Authorization", 'Bearer '+this.DammiToken()
      ).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')      
      .set('Content-Type', 'application/json; charset=utf-8'), 
      params: new HttpParams()
    };
    
    this.AccessiExagerato = new AccessoExagerato;
    this.TokenLoggato = new AccessToken;
    this.InfoUtenteConnesso = new Utente;
    let OBJ = sessionStorage.getItem('userrentrincloud');
    let OBJ1 = sessionStorage.getItem('EXAGERATOWEB');
    console.log("wwwwwwwwwwwwwwwwwwwwww", OBJ);
    sessionStorage.clear();

    //sessionStorage.removeItem('userrentrincloud');
    //sessionStorage.removeItem('EXAGERATOWEB');
    //sessionStorage.removeItem('EXAGERATOWEBTOKEN');
    
    const EndPoint=environment.BASE_API_URL+"token/Logout";
    const HeaderOdata=httpOptions;
    this.httpClientNoInterceptor.get(EndPoint,HeaderOdata)
    .toPromise()
    .then(response  =>{
      response
    }) 
    .catch();
  
    
    //Andrebbero pulite anche le variabili in localstorage per i filtri
    localStorage.removeItem('Filtri');

    sessionStorage.removeItem('currentTabsItems');
    sessionStorage.removeItem('navComponent');



  }

public DammiCausaliRifiutiInBaseAiPermessi(){
  let httpOptions = {
      headers: new HttpHeaders().set(
        "Authorization", 'Bearer '+this.DammiToken()
      ).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')      
      .set('Content-Type', 'application/json; charset=utf-8'), 
      params: new HttpParams()
    };
    const EndPoint=environment.BASE_API_URL+"CausaleRifiuti";//+this.InfoUtenteConnesso.idAccount;
    const HeaderOdata=httpOptions;
    this.httpClientNoInterceptor.get(EndPoint,HeaderOdata)
  .toPromise()
  .then(response  =>{ 
    if(this.InfoUtenteConnesso.idtipoutente <5) return  response;   
    console.log("eeco le causali ",response);
    console.log('Ecco i permessi ',this.InfoUtenteConnesso.permessi)
    let causaliFiltrate=response.filter(elem=>{

      if(!this.InfoUtenteConnesso.permessi)
        return;

      let Az=this.InfoUtenteConnesso.permessi[0].aziendaCausaliPosizioni.filter(elemAz=>{
          return elemAz.idAzienda=this.InfoUtenteConnesso.aziendaSelected;
      })
      if(Az.length>0){ // Azienda 
        console.log("HO TROVATO AZIENDA ",Az)
        //const found = array1.find((element) => element > 10);
        let trovCaus=Az[0].idCausali.find((element) =>{ return element ==  elem.id});
        if(trovCaus==undefined){
          //
        }else return elem 

      }      
    })
    console.log("Ecco Le causali Filtrate ",causaliFiltrate)
    return causaliFiltrate;
    //this.InfoUtenteConnesso.permessi
    //response.id      
    //this.InfoUtenteConnesso.aziende=response[0].listaAziendeAbilitate  
  }) 
  .catch();
    

}

  public settaMenuInBaseAiPermessi(menu){
    this.DammiCausaliRifiutiInBaseAiPermessi();
    if(this.InfoUtenteConnesso.idtipoutente==5){      
      let httpOptions = {
        headers: new HttpHeaders().set(
          "Authorization", 'Bearer '+this.DammiToken()
        ).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')      
        .set('Content-Type', 'application/json; charset=utf-8'), 
        params: new HttpParams()
      };
      const EndPoint=environment.BASE_API_URL+"Gruppo/GetAllByUserId/"+this.InfoUtenteConnesso.idAccount;
      const HeaderOdata=httpOptions;
      this.httpClientNoInterceptor.get(EndPoint,HeaderOdata)
    .toPromise()
    .then(response  =>{        
    let p = response.filter((data) => {
        return data.listaAziendeAbilitate.includes(this.InfoUtenteConnesso.aziendaSelected);
    });
    if(p.length==0){
      alert("Non Puoi piu Accedere all'azienda selezionata");
      this.LogOut();
      this.router.navigate(['/login']).then(() => {
        sessionStorage.removeItem('currentTabsItems')
        sessionStorage.removeItem('navComponent')
        sessionStorage.removeItem('currentTabsData')

      });
      return;
    }
    //this.InfoUtenteConnesso.aziende=response[0].listaAziendeAbilitate
    this.InfoUtenteConnesso.permessi=p;
   
    menu.forEach(elemMenu=>{
      elemMenu.items.forEach(item=>{
        item.items.forEach(elem=>{
          elem.items.forEach(voce=>{
            //console.log("Voceeeeeeeeeeeeeeee Prima",voce.id,voce.disabled)
            let Perm=this.DammiPermessiFunzione(voce.id);
              voce.disabled= (Perm=='' || Perm=='S')
              //console.log("Voceeeeeeeeeeeeeeee Dopo",voce.id,voce.disabled)
          })      
        })          
      })
  })


     
    }) 
    .catch();
      

    }

  }

  public DammiPermessiFunzione(value){    

    //C=Cancellazione;I=Inseromento;M=Modifica;V=Visualizzazione;S=Speciale
    let result='CIMVS';
    const tipoUtenteConnesso = this.DammiTipoUtente();

    if((tipoUtenteConnesso != 4 && tipoUtenteConnesso != 5) || !this.InfoUtenteConnesso.permessi) return result 

    const permessiRelativiAFunzione = (this.InfoUtenteConnesso.permessi[0].funzioni as any[]).find( x => x['idMenuFunzioni'] == value);
    
    if(!permessiRelativiAFunzione)
      return result;

    result = "";

    if(permessiRelativiAFunzione['cancellazione'])
      result += 'C';

    if(permessiRelativiAFunzione['inserimento'])
      result += 'I';
    
    if(permessiRelativiAFunzione['modifica'])
      result += 'M';

    if(permessiRelativiAFunzione['visualizzazione'])
      result += 'V';

    if(permessiRelativiAFunzione['speciale'])
      result += 'S';
    

    return result;
  }


  public DammiTipoUtente() {
    return this.InfoUtenteConnesso.idtipoutente;
    //return this.InfoDatiUtenteConnesso.owner)
  }
  public DammiDescrizioneTipoUtente() {
    return this.InfoUtenteConnesso.tipoutente;
    //return this.InfoDatiUtenteConnesso.owner)
  }
  public DammiToken() {
    //console.log("Ecco la data ",Date.now())
    this.UltimoAccesso.next(Date.now());
    return this.TokenLoggato.access_token;
  }
  public SetToken(token) {
    
    this.TokenLoggato.access_token = token;
    //console.log("Token In SetTpken " + token);
  }
  public SetUserLicenze(value) {
    this.InfoDatiUtenteConnesso.licenze = value;
    this.InfoUtenteConnesso.licenze = value;
    console.log("Ecco utente connesso in SetUserLicenze", value);

  }
  public SetetUserInfo(value) {
    let found=null
    
    if(value.aziende)
    found = value.aziende.find((elementX) => {
      return elementX.id === value.aziendaSelected;
    });
    if (found !== undefined && found !== null) {
      value.aziendaSelectedAnnoInstallazione=found.annoInstallazione
      
    }
    //value.annoSelected=2024
    
    this.InfoDatiUtenteConnesso = value;
    this.InfoUtenteConnesso = value;

    if(value.tipoUtente==5){
      console.log("Setet UserInfo000000000000000");
      console.log(value)
      let httpOptions = {
        headers: new HttpHeaders().set(
          "Authorization", 'Bearer '+this.DammiToken()
        ).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')      
        .set('Content-Type', 'application/json; charset=utf-8'), 
        params: new HttpParams()
      };
      const EndPoint=environment.BASE_API_URL+"Gruppo/GetAllByUserId/"+value.id;
    const HeaderOdata=httpOptions;
    this.httpClientNoInterceptor.get(EndPoint,HeaderOdata)
    .toPromise()
    .then(response  =>{        
    let p = response.filter((data) => {
        return data.listaAziendeAbilitate.includes(this.InfoUtenteConnesso.aziendaSelected);
    });
    if(p.length==0){
      alert("Sei stato disabilitato all'accesso per l'azienda selezionata");
      this.LogOut();
      this.router.navigate(['/login']).then(() => {
        sessionStorage.removeItem('currentTabsItems')
        sessionStorage.removeItem('navComponent')
        sessionStorage.removeItem('currentTabsData')

      });
      return;
    }
    this.InfoUtenteConnesso.permessi=p;
    console.log("Ecco InfoUtenteConnesso con gruppo ",this.InfoUtenteConnesso)  
     
    }) 
    .catch();
      

    }




    //this.InfoDatiUtenteConnesso.idtipoutente=value.tipoUtente;
//    console.log("Ecco utente connesso in SetUserInfo", value);

    if (value.isOwner == true) {
      value.tipoUtente = 1;
      value['licenzeSelected'] = "00000";
      this.InfoUtenteConnesso.idtipoutente = 1;
      this.InfoUtenteConnesso.tipoutente = "Owner";
    }
    else {
      if (value.tipoUtente) {
        this.InfoUtenteConnesso.idtipoutente = value.tipoUtente;
        let tt = this.tipoutente.filter(x => x.id === value.tipoUtente);
        this.InfoUtenteConnesso.tipoutente = tt[0]['descrizione'];
      }
    }
    //this.InfoDatiUtenteConnesso=value;
   // console.log("Ecco utente connesso InfoDatiUtenteConnesso", value);
    //alert(this.InfoDatiUtenteConnesso.tipoUtente);
    if (!this.InfoDatiUtenteConnesso.tipoutente) return;
    this.InfoUtenteConnesso.licenza = value['licenzeSelected'];
    //console.log("wwwwwwwwww", this.getDimensionsByFilter(value['licenzeSelected'], value['licenze']));
    this.InfoUtenteConnesso.descr_licenza = (this.getDimensionsByFilter(value['licenzeSelected'], value['licenze']))[0].descrizione;
    this.InfoUtenteConnesso.foto = value['foto'];
    this.InfoUtenteConnesso.idAccount = value['id'];
    this.InfoUtenteConnesso.userName = value['userName'];
    this.InfoUtenteConnesso.nomeCompleto = value['nomeCompleto'];
    //this.InfoUtenteConnesso.annoSelected=2024
    //this.InfoDatiUtenteConnesso.scadenzaPassword=new Date((value['scadenzaPassword'] as string).split('T')[0]);
    this.InfoDatiUtenteConnesso.scadenzaPassword=value['scadenzaPassword'] ? new Date((value['scadenzaPassword'] as string)) : undefined;  //new Date((value['scadenzaPassword'] as string));
    var UtentiCheHannoAvutoAccesso = [];


    var credenziali = {
      licenza: value['licenzeSelected'],
      descr_licenza: this.InfoUtenteConnesso.descr_licenza,
      foto: this.InfoUtenteConnesso.foto,
      nomeCompleto: this.InfoUtenteConnesso.nomeCompleto,
      userName: this.InfoUtenteConnesso.userName,
      remember: 0
    };
    var tt = localStorage.getItem('artemide_credenziali');
    if (tt)
      UtentiCheHannoAvutoAccesso = JSON.parse(localStorage.getItem('artemide_credenziali'));
    if (UtentiCheHannoAvutoAccesso) {

      var __FOUND = UtentiCheHannoAvutoAccesso.findIndex(function (post, index) {
        if (post.userName == value['userName'])
          return true;
      });




      let result = UtentiCheHannoAvutoAccesso.find(({ userName }) => userName === value['userName']);
      if (__FOUND > -1) {
        //alert("trovato");
        UtentiCheHannoAvutoAccesso[__FOUND] = credenziali;
      } else {
        //alert("Non trovato");
        UtentiCheHannoAvutoAccesso.push(credenziali);
      }
    } else {
      UtentiCheHannoAvutoAccesso = [];
      //JSON.parse(JSON.stringify(data.object));
      UtentiCheHannoAvutoAccesso.push(credenziali);
      console.log("wwwwwwwwwwwww", UtentiCheHannoAvutoAccesso)
    }


    //console.log("wwwwwwwwwwwww1111111111", JSON.stringify(UtentiCheHannoAvutoAccesso))

    localStorage.setItem('artemide_credenziali', JSON.stringify(UtentiCheHannoAvutoAccesso));
   // console.log("Session Storage", localStorage.getItem('artemide_credenziali'))
    this.InfoUtenteConnesso.logIn = true;

    sessionStorage.setItem('userrentrincloud', JSON.stringify(this.InfoUtenteConnesso));
    sessionStorage.setItem('EXAGERATOWEB', JSON.stringify(this.AccessiExagerato));
    sessionStorage.setItem('EXAGERATOWEBTOKEN', JSON.stringify(this.TokenLoggato));    
    this.changedUser.next(this.InfoUtenteConnesso);
    this.setValueAnnoRiferimento(this.InfoDatiUtenteConnesso.annoSelected)



    setTimeout(() => {
      //this.changedUser.next(this.InfoUtenteConnesso);
      // this.menuservice.setIdCurrentApp(1);
      //this.changedApplication.next();
      //alert("Emit Change");
    }, 1000);
  }

  setUserInfoRentri(value){
    this.InfoUtenteConnesso = value
    this.InfoUtenteConnesso.idtipoutente = 4;
    this.InfoUtenteConnesso.tipoutente = "Rentri";
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) {

    if(state.url == 'AppProva'){
      this.router.navigateByUrl('https://www.google.it');
    }

    if (this.InfoUtenteConnesso.logIn && this.InfoUtenteConnesso.idtipoutente > 2) {
      this.checSessionError=true;
      return true;
    }

    if (this.InfoUtenteConnesso.logIn && this.InfoUtenteConnesso.idtipoutente == 1) {
      this.checSessionError=true;
      return true;
    }

    //console.log(this.InfoDatiUtenteConnesso.idtipoutente)
    
    if (this.InfoUtenteConnesso.logIn && this.InfoUtenteConnesso.idtipoutente == 2) {
      this.checSessionError=true;
      return true;
    }
    if (this.InfoUtenteConnesso.logIn && this.InfoUtenteConnesso.idtipoutente == 4) {
      this.checSessionError=true;
      return true;
    }
    this.checSessionError=false;
    this.componentService.destroyCurrentOpenPopUps()
    this.router.navigate(['/login']);
  }
   encrypt(data: string): string {
      let secretKey="miachiave"
      let encoded = '';
      for (let i = 0; i < data.length; i++) {
        encoded += String.fromCharCode(data.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length));
      }
      return btoa(encoded).replace(/=+$/, '');
      //return btoa(encoded); // Codifica in Base64
    }
  


}

